// extracted by mini-css-extract-plugin
export default {"info":"_eebe90d1","photo":"_456386d3","title":"_256b5a7f","description":"_c9eee099","expandableWrapper":"_62579c20","content":"_52184516"};